<template>
  <div class="wrapper-component" :class="customClass">
    <v-select
      ref='vSelect'
      :disabled="disabled"
      :value="newValue"
      @input="selectAnItem($event)"
      :label="label"
      :options="options"
      :reduce="(record) => reduceARecord(record)"
      :dir="direction"
      :multiple="multiple"
      :selectable="(option) => { return disabledItems.length ? isDisabled(option) : true;}"
      :searchable="searchable"
      :filterable="!!options && !!options.length && filterable"
      :filter="filter"
      :clearable="clearable"
      @search="$emit('search', $event)"
    >
      <template v-if="translate" v-slot:option="option" disabled>
        <span v-for="label in concatLabel" :key="label[0]">
          <span v-if="option[label]">
            {{ $t(translateObj + `.${option[label]}`) }}&nbsp
          </span>
        </span>
      </template>

      <template v-else v-slot:option="option">
        <span v-for="(label, index) in concatLabel" :key="index">
          <span v-if="lodashGet(option, label)">
            {{ lodashGet(option, label) }}&nbsp
          </span>
        </span>
      </template>

      <template v-if="translate" v-slot:selected-option="option">
        <span v-for="label in concatLabel" :key="label[0]">
          <span v-if="option[label]">
            {{ $t(translateObj + `.${option[label]}`) }}
          </span>
        </span>
      </template>

      <template v-else v-slot:selected-option="option">
        <span v-for="(label, index) in concatLabel" :key="index">
          <span v-if="option[label] && translateObj">
            {{ $t(translateObj + `.${option[label]}`) }}&nbsp
          </span>
          <span v-else> {{ lodashGet(option, label) }}&nbsp </span>
        </span>
      </template>
      <template v-slot:no-options="option">
        <span>
          {{ $t("toastification.sorryNoMatchingOptions") }}
        </span>
      </template>
    </v-select>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { uniqueId } from "lodash/util";
import Vue from "vue";
export default {
  name: "MyVSelect",
  props: {
    disabled: {
      default: false,
    },
    focus: {
      default: false,
    },
    value: {
      default: null,
    },
    label: {
      default: null,
    },
    translate: {
      default: false,
    },
    options: {
      default: function () {
        return [{ _id: "", title: "" }];
      },
    },
    reduceField: {
      type: Array,
      default: function () {
        return ["_id"];
      },
    },
    customClass: {
      default: "",
    },
    direction: {
      default: "rtl",
    },
    multiple: {
      default: false,
    },
    searchable: {
      default: false,
    },
    filterable: {
      default: false,
    },
    translateObj: {
      default: null,
    },
    clearable:{
      default: true,
    },
    concatLabel: {
      type: Array,
      default: function () {
        return ["title"];
      },
    },
    disabledItems: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: {
    vSelect,
  },
  watch:{
    options(){
      if (!!this.options && this.options.length ===  1){
        // this.selectAnItem(this.reduceARecord(this.options[0]))
      }
      else if(!this.options && this.options.length !==  1 && this.newValue){
        this.selectAnItem(null)
      }
    },
    value(oldVal,newVal){
      if(oldVal == null && oldVal != newVal){
        this.value = null
        this.newValue = null
      }
      
    }
  },
  data: function () {
    return {
      newValue: this.value,
    };
  },
  mounted() {
    if (this.focus && !this.newValue) {
      this.$nextTick(() => {
        const input = this.$refs.vSelect.$el.querySelector('input')
        input.focus()
      })
    }
  },
  methods: {
    lodashGet(option, label) {
      return _.get(option, label);
    },
    selectAnItem(event) {

      this.newValue = event;
      // if (this.reduceField.length > 1) {
      //   this.reduceField.forEach((r, index) => {
      //     if (index == 0)
      //       this.key =  _.get(_.cloneDeep(
      //           event
      //       ), r)
      //   });
      // } else {
      //   this.key = _.get(_.cloneDeep(
      //       event
      //   ), this.reduceField[0])
      // }
      this.$emit("input", event);
    },
    getOptionLabel(option) {
      if (typeof option === "object") {
        return this.concatLabel.map((label) => {

          // if (!option.hasOwnProperty(label)) {
          if (!_.get(option, label)) {
            return console.warn(
              `[vue-select warn]: Label key "option.${this.label}" does not` +
                ` exist in options object ${JSON.stringify(option)}.\n` +
                "https://vue-select.org/api/props.html#getoptionlabel"
            );
          }
          return _.get(option, label);
        });
      }
      return option;
    },
    filterBy(option, label, search) {
      return (
        (label || "").toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) >
        -1
      );
    },
    filter(options, search) {
      return options.filter((option) => {
        let label = this.getOptionLabel(option);
        let found;
        return label.some((l) => {
          if (typeof l === "number") {
            l = l.toString();
          }
          return this.filterBy(option, l, search);
        });
      });
    },
    isDisabled(option) {
      let disable = false;
      let parent = this;
      let a = this.disabledItems;
      return !this.reduceField.some((rf) => {
        parent.disabledItems.forEach((dis) => {
          disable = dis[rf] == option[rf];
        });
        if (disable) return disable;
      });
    },
    reduceARecord(record) {
      let temp = {};
      if (this.reduceField.length > 1) {
        this.reduceField.forEach((r) => {
          this.$set(temp, r, _.get(record, r));
        });
        return temp;
      } else {
        return _.get(record, this.reduceField[0]);
      }
    },
  },
};
</script>
